import { render, staticRenderFns } from "./materialOutput.vue?vue&type=template&id=08b09a61&scoped=true"
import script from "./materialOutput.vue?vue&type=script&lang=js"
export * from "./materialOutput.vue?vue&type=script&lang=js"
import style0 from "./materialOutput.vue?vue&type=style&index=0&id=08b09a61&prod&lang=scss&scoped=true"
import style1 from "./materialOutput.vue?vue&type=style&index=1&id=08b09a61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b09a61",
  null
  
)

export default component.exports